/* eslint-disable max-len */
import * as React from "react";


export interface Props {
    pageTitle: string;
}

const Breadcrumbs = ({ pageTitle }: Props) => {
    return ( 
        <main id="main-content" className="grid-container overflow-hidden bg-white">
            <div className="padding-top-1px tablet:padding-y-0 grid-row margin-x-neg-1 tablet:margin-x-0"> 
                <div className="grid-col-12 order-1 tablet:order-2 tablet:margin-x-2 margin-bottom-2 tablet:margin-y-2 font-alt-2xs text-ls-2 text-gray text-italic">
                    <nav aria-label="breadcrumb" id="usa-breadcrumbs">
                        <div className="usa-breadcrumb">
                            <ol className="padding-left-0 margin-top-0">
                                <li className="display-inline">
                                    <a className="text-prussian-blue" href="https://www.fdic.gov/index.html" aria-label="FDIC.gov home page">Home</a>
                                </li>
                                <li className="display-inline"><a className="text-prussian-blue text-capitalize" aria-label="Resources" href="https://www.fdic.gov/index.html" >Resources</a>  </li>
                                <li className="display-inline"><a className="text-prussian-blue text-capitalize" aria-label="Resolutions" href="https://www.fdic.gov/resources/resolutions/" >Resolutions</a>  </li>
                                <li className="display-inline"><a className="text-prussian-blue text-capitalize" aria-label="Bank Failures" href=" https://www.fdic.gov/resources/resolutions/bank-failures/">Bank Failures</a> </li>
                                <li className="display-none tablet:display-inline"><a className="text-prussian-blue text-capitalize" aria-label="Templates" aria-current="page" href="/aii/">Is My Account Fully Insured? </a></li>
                            </ol>
          
                            {/* <ol className="padding-left-0 margin-top-0">
        <li className="display-inline">
          <a className="text-prussian-blue" href="https://www.fdic.gov/index.html" aria-label="FDIC.gov home page">Home</a>
        </li>
      <li className="display-inline"><a className="text-prussian-blue text-capitalize" aria-label="Assets" href=" https://www.fdic.gov/bank/index.html " >Industry Analysis</a>  </li>
          <li className="display-inline"><a className="text-prussian-blue text-capitalize" aria-label="Assets" href=" https://www.fdic.gov/resources/resolutions/bank-failures/failed-bank-list/index.html ">Failed Banks</a> </li>
          <li className="display-none tablet:display-inline"><a className="text-prussian-blue text-capitalize" aria-label="Templates" aria-current="page" href="/">Is My Account Fully Insured? </a></li>
          </ol>
    */}
                            {/* <a className="text-capitalize" href="https://www.fdic.gov/index.html" aria-label="FDIC.gov home page">Home</a> 
      <a className="text-capitalize" aria-label="Assets" href=" https://www.fdic.gov/bank/index.html " >Industry Analysis</a>
      <a className="text-capitalize" aria-label="Assets" href=" https://www.fdic.gov/resources/resolutions/bank-failures/failed-bank-list/index.html ">Failed Banks</a>
      <a className="text-prussian-blue text-capitalize" aria-label="Templates" aria-current="page" href="/">Is My Account Fully Insured? </a>
     */}
                            {/* <a href="https://www.fdic.gov/index.html" style={{ fontStyle: "italic" }} >  Home    </a> //
      <a href="https://www.fdic.gov/bank/index.html" style={{ fontStyle: "italic" }} > Industry Analysis</a> // 
      <a href="https://www.fdic.gov/bank/individual/failed/index.html" style={{ fontStyle: "italic" }} > Failed Banks </a> // { " "} 
      {/* {/* <span style={{ fontStyle: "italic" }}>  { pageTitle}  </span> */}
                        </div>
                    </nav>
                </div>
            </div>
        </main>
    );
};

export default Breadcrumbs;
